import { OTP_STATE } from "app/components/verify-otp/otp-state";

export class PIN_STATE extends OTP_STATE {
    public static readonly CHECKOUT = 'checkout';
    public static readonly SET_PIN = 'set_pin';
    public static readonly CONFIRM_SET_PIN = 'confirm_set_pin';
}


// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-pin/pin-state.ts